import { useState } from "preact/hooks";

import { Form } from "@components/kit/form";
import { PageHeader } from "@components/kit/page-header";
import { Button } from "@components/ui/interactive/button";
import { Container } from "@components/ui/structure/container";
import { LoadingView } from "@components/view/loading-view";
import { useRoleManagement } from "@contexts/role-management";
import { useClasses } from "@styles";

export function RoleManagementView() {
  const { ready, create } = useRoleManagement();
  const [name, setName] = useState<string>("");

  if (!ready)
    return <LoadingView />

  return (<>
    <Container className={useClasses("um-content")}>
      <PageHeader
        icon="BrightCrownRegular"
        title="Role Management"
      />

      <Container className={useClasses("um-layout")}>
        <Form
          fields={[
            {
              label: "Role Name",
              type: "tel",
              value: name,
              updateValue: (value) => setName(value),
            },
          ]}
        />

        <Button
          icon="DatabaseScriptPlusRegular"
          title="Create Role"
          hoverText="Create New Role"
          disabled={!name}
          onClick={() => create(name)}
        />
      </Container>
    </Container>
  </>);
}

